import React from 'react';
import {CreatorsListDM, PresetSizes} from "../interfaces";
import Gallery from "../../../galleries/gallery/gallery";
import { ProfileDM } from '../../common/interfaces';
import CreatorItem from "./creator-item";
import {useWindowSize} from "../../../../domain/common";
import {OLP_DESKTOP_BREAKPOINT} from "../constants";

export interface CreatorListProps {
    creatorsIDs:number[];
    creatorListData:CreatorsListDM;
    imgCdnDomain:string;
    creatorsPath:string;
    isDarkBackground?:boolean;
    loop?:boolean;
    presetSizes?:string | null;

}
const CreatorList = (props:CreatorListProps) => {


    const ListCreators = props.creatorsIDs.map(creatorId => (props.creatorListData.profiles as ProfileDM[]).filter(creator => creatorId === creator.profileID)[0]);
    const size = useWindowSize();

    const isDesktop = size.width !== undefined && size.width > OLP_DESKTOP_BREAKPOINT;
    const presetSizes: PresetSizes = JSON.parse(props.presetSizes || '{"d":5.5,"t":2.5,"m":1.2}') as PresetSizes;
    const DesktopItemsPerSlide = isDesktop ? presetSizes.d : 3;
    //if the list's length is the same as the number of items that ara visible --> disable loop (hide arrows)
    const isLoop = (isDesktop && ListCreators.length <= DesktopItemsPerSlide) ? false : props.loop;
    return (
        <div className="w-full" id="gallery-container">
            <Gallery
                allowVerticalScrolling={ true }
                isArrowsOverflow={true}
                //for StudioVerse --> positioning the arrows in the middle of the preset's and creator's image height
                //When this prop is defined, set the arrows height to slideItemWidth * arrowsHeightWidthRatio
                arrowsHeightWidthRatio={1}
                //for lg size set desktopItemsPerSlide to 3
                desktopItemsPerSlide={ DesktopItemsPerSlide }
                tableItemsPerSlide={ presetSizes.t }
                mobileItemsPerSlide={ presetSizes.m }
                codeName="cp"
                items={ ListCreators }
                gap={ 43}
                loop={ isLoop }
                classes="w-full"
                duration={ 800 }
                arrowsColor={props.isDarkBackground ? "white" : undefined}
                renderItem={(profile: ProfileDM, slideItemWidth: number) => {

                    return (
                        <div className="perspective backface-visibility" key={profile.profileID}  >
                            <CreatorItem isDarkBackground={props.isDarkBackground ? props.isDarkBackground : false} creator={profile} imgCdnDomain={props.imgCdnDomain} creatorsPath={props.creatorsPath} imgWidth={slideItemWidth} imgHeight={slideItemWidth} />
                        </div>

                    )
                }}
            />
        </div>


    )
};

export default CreatorList;